<div class="global_wrap">
  <router-outlet></router-outlet>

  <div class="global_wrap_bg" [ngStyle]="{'background-image': 'url(' + ('bg.png' | imagePath) + ')'}"></div>
</div>
